import React from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useSelector } from "react-redux";

function CommandCard() {
  const deviceData = useSelector((state) => state.deviceConfig.deviceData);
  const heatData = useSelector((state) => state.deviceConfig.heatData);

  return (
    deviceData &&
    heatData && (
      <MDBox
        sx={{
          p: 3,
          // borderRadius: "12px",
          // boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
          // backgroundColor: "#fff",
          maxWidth: 500,
          margin: "auto",
        }}
      >
        {/* Title */}
        <MDTypography variant="h5" fontWeight="medium" gutterBottom>
          Device Command
        </MDTypography>

        {/* Protocol Type */}
        <MDBox mb={2}>
          <MDTypography variant="button" fontWeight="regular" mb={0.5}>
            Protocol Type
          </MDTypography>
          <MDInput
            label="Select The Command Type"
            variant="outlined"
            fullWidth
            size="small"
          />
        </MDBox>

        {/* Command */}
        <MDBox mb={3}>
          <MDTypography variant="button" fontWeight="regular" mb={0.5}>
            Command
          </MDTypography>
          <MDInput
            label="Select The Command"
            variant="outlined"
            fullWidth
            size="small"
          />
        </MDBox>

        {/* Buttons */}
        <MDBox display="flex" justifyContent="flex-end" gap={2}>
          <MDButton variant="outlined" color="error">
            Cancel
          </MDButton>
          <MDButton variant="contained" color="info">
            Clear Device
          </MDButton>
        </MDBox>
      </MDBox>
    )
  );
}

export default CommandCard;
